import PropTypes from "prop-types";

const Pagination = ({ currentPage, totalPages, limit, totalItem, onPageChange, handleLimit }) => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-between p-4 gap-4 bg-white border border-[#9FACF0] rounded-xl shadow-sm mt-6">
      <div className="text-[15px] font-medium text-gray-600 order-2 md:order-1">
        Showing <span className="text-[#1955EB]">{totalItem === 0 ? 0 : ((currentPage - 1) * limit) + 1}</span> to <span className="text-[#1955EB]">{Math.min(currentPage * limit, totalItem)}</span> of <span className="text-[#1955EB]">{totalItem}</span> entries
      </div>

      <div className="flex items-center space-x-4 order-1 md:order-2 bg-gray-50 px-3 py-1.5 rounded-lg border border-gray-100">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-1 text-sm text-[#1955EB] font-bold disabled:text-gray-400 hover:bg-white rounded-md transition-colors"
        >
          Prev
        </button>

        <div className="flex items-center gap-2">
          <span className="text-gray-500 text-sm font-medium">Page</span>
          <input
            type="number"
            min="1"
            max={totalPages}
            value={currentPage}
            onChange={(e) => onPageChange(Number(e.target.value))}
            className="w-12 px-1 py-1 text-sm text-center border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-[#1955EB]"
          />
          <span className="text-gray-500 text-sm font-medium">of {totalPages || 0}</span>
        </div>

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
          className="px-3 py-1 text-sm text-[#1955EB] font-bold disabled:text-gray-400 hover:bg-white rounded-md transition-colors"
        >
          Next
        </button>
      </div>

      <div className="order-3">
        <select
          className="px-3 py-1.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-[#1955EB] cursor-pointer"
          value={limit}
          onChange={handleLimit}
        >
          <option value={10}>10 / Page</option>
          <option value={20}>20 / Page</option>
          <option value={50}>50 / Page</option>
        </select>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  totalPages: PropTypes.object,
  currentPage: PropTypes.object,
  onPageChange: PropTypes.object,
  limit: PropTypes.object,
  totalItem: PropTypes.object,
  handleLimit: PropTypes.object,
};
export default Pagination;